/**
 * FacetWP
 */

 (function($) {

  // add scroll to top when pagination is used
  $(document).on('facetwp-refresh', function() {
    if ( FWP.soft_refresh == true ) {
      FWP.enable_scroll = true;
    } else {
      FWP.enable_scroll = false;
    }
  });

  $(document).on('facetwp-loaded', function() {
    if ( FWP.enable_scroll == true ) {
      $('html, body').animate({
        scrollTop: $('.facetwp-filters').offset().top // Scroll to the top of the element with class "facetwp-template"
      }, 500);
    }
  });

  document.addEventListener('facetwp-loaded', function() {

    // show hide billing information based on selected facet in contact page
    if ('undefined' !== typeof FWP.facets.henkilokunta_osastot) {

      var current_department = FWP.facets.henkilokunta_osastot[0];
      var billing = $('.billing-content');

      if(current_department) {
        $(billing).each(function(){
          $(this).css('display','none');
          if ( $(this).hasClass('billing-' + current_department) ) {
            $(this).css('display','block');
          }
        });
      } else {
        $(billing).each(function(){
          $(this).css('display','none');
          if ( $(this).hasClass('billing-millog') ) {
            $(this).css('display','block');
          }
        });
      }
    }

    // persons may have more than one term added so we want to hide duplicates when facet is selected
    if ('undefined' !== typeof FWP.facets.henkilokunta_osastot && FWP.facets.henkilokunta_osastot.length > 0 ) {
      var term_group = $('.contact-persons__wrap');

      // hide term group if it dont match current facet
      $(term_group).each(function(){
        if($(this).attr('data-term-group') != FWP.facets.henkilokunta_osastot) {
          $(this).addClass('hide');
        }
      });
    }
   });

})(jQuery);
